var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "flex justify-center items-center absolute inset-0 z-10 pointer-events-none",
    },
    _vm._l(_vm.snackbars, function (snackbarBox, i) {
      return _c(
        "div",
        { key: i, class: `p-4 absolute ${_vm.snackbarBoxPosition(i)}` },
        [
          _c(
            "transition-group",
            {
              class: `flex ${_vm.snackbarPosition(i)}`,
              attrs: { name: "fade" },
            },
            _vm._l(snackbarBox, function (snackbar, j) {
              return _c(
                "GrmSnackbar",
                {
                  key: snackbar.id,
                  class: _vm.snackbarSlide(i),
                  attrs: {
                    isOpenExtendMenu: _vm.isOpenExtendMenu,
                    snackbar: snackbar,
                    snackbars: _vm.snackbars,
                    index: j,
                  },
                  on: { hide: _vm.removeSnackbar },
                },
                [_vm._v(" " + _vm._s(snackbar.message) + " ")]
              )
            }),
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }